(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["neo-noir-vault"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (!window.customElements || window.customElements.get('neo-noir-vault')) return;

    const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    const cleanPrefix = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9-]/g, '');
    const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    class NeoNoirVault extends HTMLElement {
      connectedCallback() {
        if (this._connected) return;
        this._connected = true;

        this.toggle = this.querySelector('[data-vault-toggle]');
        this.panel = this.querySelector('[data-vault-panel]');
        this.form = this.querySelector('[data-vault-form]');
        this.input = this.querySelector('.neo-noir__input');
        this.button = this.querySelector('.neo-noir__button');
        this.message = this.querySelector('[data-vault-message]');
        this.badge = this.querySelector('[data-vault-badge]');
        this.article = this.querySelector('.neo-noir__phase');

        this.onToggle = () => this.setOpen(this.toggle.getAttribute('aria-expanded') !== 'true');
        this.onSubmit = (event) => {
          event.preventDefault();
          this.check();
        };
        this.onInput = () => {
          if (this.input.getAttribute('aria-invalid') !== 'true') return;
          this.input.removeAttribute('aria-invalid');
          this.say('');
        };

        this.toggle.addEventListener('click', this.onToggle);
        this.form.addEventListener('submit', this.onSubmit);
        this.input.addEventListener('input', this.onInput);
      }

      disconnectedCallback() {
        this.toggle.removeEventListener('click', this.onToggle);
        this.form.removeEventListener('submit', this.onSubmit);
        this.input.removeEventListener('input', this.onInput);
        this._connected = false;
      }

      setOpen(open) {
        this.toggle.setAttribute('aria-expanded', String(open));
        this.panel.hidden = !open;
        if (open) this.input.focus();
      }

      say(text, type) {
        this.message.textContent = text;
        this.message.dataset.type = type || '';
      }

      fail(text, shake) {
        this.say(text, 'error');
        this.input.setAttribute('aria-invalid', 'true');
        if (shake) {
          this.article.classList.remove('is-error');
          void this.article.offsetWidth;
          this.article.classList.add('is-error');
        }
        this.input.focus();
        this.input.select();
      }

      async check() {
        if (this.busy) return;
        const code = normalize(this.input.value);
        if (!code) {
          this.fail(this.dataset.emptyMessage || 'Enter the password.', false);
          return;
        }

        const root = (this.dataset.root || '/').replace(/\/$/, '');
        const url = `${root}/products/${cleanPrefix(this.dataset.prefix)}${code}`;

        this.busy = true;
        this.button.setAttribute('aria-busy', 'true');
        let granted = false;
        try {
          const [response] = await Promise.all([
            fetch(`${url}.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }),
            wait(500),
          ]);
          granted = response.ok;
        } catch (error) {
          console.error('[Neo Noir Vault] Check failed:', error);
        }
        this.busy = false;
        this.button.removeAttribute('aria-busy');

        if (!granted) {
          this.fail(this.dataset.errorMessage || 'Access denied', true);
          return;
        }

        this.article.dataset.state = 'solved';
        if (this.badge) this.badge.textContent = 'Granted';
        this.say(this.dataset.successMessage || 'Access granted', 'success');
        window.location.href = url;
      }
    }

    window.customElements.define('neo-noir-vault', NeoNoirVault);
  })();

  } catch(e) { console.error(e); }
})();
})();
